import React, { Fragment } from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import ActionsBlock from './ActionsBlock';
import * as RegistrationListSelectors from '../../../../redux/reducers/registration_list_reducer/selectors';
import { StateStatus } from '../../../../redux/utils/common';
import { useDispatch } from 'react-redux';
import RegistrationListActions from '../../../../redux/reducers/registration_list_reducer/actions';
import Filter from '../filter';
import useQuery from 'custom_hooks/useQuery';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles } from 'config';

export default function DatatableList() {
  const result = RegistrationListSelectors.useGetRegistrationList();
  const ROLE = AuthSelectors.useSelectUserRole();

  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('desc');

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const status = query.get('status');
  const state = query.get('state');
  const personal = query.get('personal');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(status && { status }),
    ...(state && { state }),
    ...(personal && { personal }),
  };
  return (
    <Fragment>
      {(ROLE === AuthRoles.Agent || ROLE === AuthRoles.Admin) && (
        <Filter
          vat_number={vat_num}
          status={status}
          state={state}
          personal={personal}
          role={ROLE}
        />
      )}

      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            RegistrationListActions.fetchRegistrationListAction({
              sortField: _sortField,
              page: selectedPage,
              pageSize: pageSize,
              order: order,
              ...searchParams,
            })
          );
        }}
      />
    </Fragment>
  );
}

export { ActionsBlock };
